<template>
	<div>
		<TopNav activeIndex="Mine" />
		<!-- 搜索栏 -->
		<div class="search-box">
			<el-row>
				<div class="search-item1">
					<div class="item-con">
						<div class="item-con-tle">搜&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;索：</div>
						<el-input
							class="searchtxt" size='small' @input='searchInput' :clearable='true'
							placeholder="请输入专利号/专利名称/领域" suffix-icon="el-icon-search" v-model="searval1"></el-input>
						<div class="item-ts-tle">多项搜索用英文逗号隔开</div>
					</div>
					<div class="item-con" v-if="false">
						<div class="item-con-tle">专利名称：</div><el-input size='small' @input='zlmcInput' :clearable='true'
							placeholder="请输入专利名称" suffix-icon="el-icon-search" v-model="searh_ly_val"></el-input>
					</div>
					<div class="item-con" v-if="false">
						<div class="item-con-tle">专利号：</div><el-input size='small' @input="zlhInput" :clearable='true'
							placeholder="支持多件，空格分隔" suffix-icon="el-icon-search" v-model="searh_zlh_val"></el-input>
					</div>
				</div>
			</el-row>
			<el-row>
				<div class="check-item">
					<div class="item-con-tle">专利类型：</div>
					<el-checkbox-group v-model="zlztcheckList" @change='zlztCheckChange'>
						<!-- <el-checkbox label="0">不限</el-checkbox> -->
						<el-checkbox label="1">授权未缴费发明</el-checkbox>
						<el-checkbox label="2">下证发明</el-checkbox>
						<el-checkbox label="3">授权未缴费实用</el-checkbox>
						<el-checkbox label="4">下证实用</el-checkbox>
						<el-checkbox label="5">外观</el-checkbox>
					</el-checkbox-group>
				</div>
			</el-row>
			<el-row>
				<div class="check-item">
					<div class="item-con-tle">申报状态：</div>
					<el-checkbox-group v-model="sbztcheckList" @change='sbztcheckChange'>
						<!-- <el-checkbox label="0">不限</el-checkbox> -->
						<el-checkbox label="1">已报高企</el-checkbox>
						<el-checkbox label="2">未报高企</el-checkbox>
					</el-checkbox-group>
				</div>
			</el-row>
			<el-row>
				<div class="check-item">
					<div class="item-con-tle">专利分类：</div>
					<el-checkbox-group v-model="zlflcheckList" @change='zlflcheckChange'>
						<el-checkbox label="1">实时</el-checkbox>
						<el-checkbox label="2">代售</el-checkbox>
					</el-checkbox-group>
				</div>
			</el-row>
			<el-row>
				<div class="check-item">
					<div class="item-con-tle">预定状态：</div>
					<el-checkbox-group v-model="ydztcheckList" @change='ydztcheckChange'>
						<!-- <el-checkbox label="0">不限</el-checkbox> -->
						<el-checkbox label="1">待出售</el-checkbox>
						<el-checkbox label="4">已预定</el-checkbox>
						<el-checkbox label="3">我预定/排队的</el-checkbox>
						<!-- <el-checkbox label="4">我排队的</el-checkbox> -->
					</el-checkbox-group>
				</div>
			</el-row>
			<el-row>
				<div class="fw-item">
					<div class="item-con-tle">价格范围：</div>
					<el-input class="item-con-ipt" @input='zdjInput1' size='small' v-model="searh_zdj1_val"
						:clearable='true' type="number" placeholder="价格最低值"></el-input>-
					<el-input class="item-con-ipt" @input='zdjInput2' size='small' v-model="searh_zdj2_val"
						:clearable='true' type="number" placeholder="价格最高值"></el-input>
				</div>
			</el-row>
			<el-row>
				<div class="check-item">
					<div class="item-con-tle">操&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;作：</div>
					<el-button type="primary" size="small" @click="addPatentShow()"
						icon="el-icon-folder-add">新增</el-button>
					<el-button type="primary" size="small" icon="el-icon-copy-document" plain
						@click='copyzl'>复制</el-button>
					<el-button @click='delzl' type="danger" size="small" icon="el-icon-delete">删除</el-button>
					<el-button @click='yjdelzl' type="danger" size="small" icon="el-icon-delete">一键删除</el-button>
					<!-- <el-button type="warning" size="small" icon="el-icon-refresh">批量更新</el-button> -->
					<el-button type="primary" size="small" @click="exportexecl()" icon="el-icon-upload2">导出</el-button>
					<el-upload ref="upload" accept='.xls,.xlsx,.csv' :http-request='uploadelc' class="upload-demo" action="https://jsonplaceholder.typicode.com/uploadexlec	/" :multiple='false':limit="1" :on-error="onErrorFile" :on-success='onSuccessFile'>
						<el-button type="primary" size="small" icon="el-icon-download">导入</el-button>
					</el-upload>
					<el-button type="text" size="small"><el-link type="primary" href="https://zhuanliy.com/uploads/用户导入模板.xlsx" target="_blank">下载导入模板</el-link></el-button>
				</div>
			</el-row>
		</div>

		<!-- 内容 -->
		<div class="con-box">
			<div class="con-tle-box">
				<el-popover placement="top-start" title="标题" width="200" trigger="hover" content="搜索到的专利数量">
					<div slot="reference">搜索到的专利总数：<el-link>{{total}}</el-link></div>
				</el-popover>
				<el-popover style="margin-left: 15px;" class="popover" placement="top-start" width="200" trigger="hover"
					content="今日新增的专利数量">
					<div slot="reference">今日新增：<el-link>{{daytotal}}</el-link></div>
				</el-popover>
				<!-- <div class="con-tle-right" @click="showlsyydialog">
					我的预定列表
				</div> -->
			</div>
			<el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" :key="key"
				@row-dblclick="handleDblClick" @selection-change="handleSelectionChange" @sort-change="handleSortChange" stripe>
				<el-table-column type="selection" width="45">
				</el-table-column>
				<el-table-column label="#" type='index' :index='getIndex' width="45">
					<!-- <template slot-scope="scope">
						<div>1</div>
					</template> -->
				</el-table-column>
				<el-table-column prop="" sortable label="专利信息" width="550">
					<template slot-scope="scope">
						<div class="con-zlxx">
							<div class="con-zlxx-1">
								<el-tag type="success" style="margin-right: 8px;" v-if="scope.row.classtype == 1" size='small'>实时</el-tag>
								<el-tag type="warning" style="margin-right: 8px;" v-if="scope.row.classtype == 2" size='small'>代售</el-tag>
								专利号：
								<span class="code" @click="copytxt(scope.row.patentnum+ ' ' + scope.row.patentname+ ' ' + scope.row.paymenttime)">{{scope.row.patentnum}}</span>
								<span class="code-a" @click="copytxt(scope.row.patentnum+ ' ' + scope.row.patentname+ ' ' + scope.row.paymenttime)">{{scope.row.patentname}}</span>
							</div>
							<!-- <div class='con-zlxx-2'>
								专利名称：
								<span class="code" @click="copytxt(scope.row.patentname)">{{scope.row.patentname}}</span>
							</div> -->
							<div class='con-zlxx-3'>
								类型：
								<span v-if="scope.row.type == 1">授权未缴费发明</span>
								<span v-else-if="scope.row.type == 2">下证发明</span>
								<span v-else-if="scope.row.type == 3">授权未缴费实用</span>
								<span v-else-if="scope.row.type == 4">下证实用</span>
								<span v-else-if="scope.row.type == 5">外观</span>
							</div>
							<div class='con-zlxx-3' v-if="scope.row.area">
								领域：{{scope.row.area}}
							</div>
							<div class='con-zlxx-4'>
								<span style="margin-right: 10px;" v-if="scope.row.paymenttime_text && scope.row.paymenttime != 0">缴费日期：{{scope.row.paymenttime_text}}</span>
								<el-tag type="danger" v-if="scope.row.ifhigh == 1"
									size='small'>已报过</el-tag>
							</div>
						</div>
					</template>
				</el-table-column>
				<!-- <el-table-column label="领域" prop="area" width="320" show-overflow-tooltip>
					<template slot-scope="scope">
						<span v-if="!scope.row[scope.column.property + 'Show']">{{scope.row.area}}</span>
						<el-input v-else type="textarea" ref="enddateinputRefs" v-model="scope.row.area"
							@blur="onBlur(scope.row, scope.column)" size="mini"></el-input>
					</template>
				</el-table-column> -->
				<el-table-column label="备注" prop="remarks" width="300">
					<template slot-scope="scope">
						<!-- <div>备注</div> -->
						<span v-if="!scope.row[scope.column.property + 'Show']">{{scope.row.remarks}}</span>
						<el-input v-else type="textarea" ref="enddateinputRefs" v-model="scope.row.remarks"
							@blur="onBlur(scope.row, scope.column)" size="mini"></el-input>
					</template>
				</el-table-column>
				<el-table-column sortable="custom" label="转让裸价" align='center' prop="guideprice" width="120">
					<!-- <div>备注</div> -->
					<template slot-scope="scope">
						<!-- <div>备注</div> -->
						<span v-if="!scope.row[scope.column.property + 'Show']">{{scope.row.guideprice}}</span>
						<el-input v-else type="textarea" ref="enddateinputRefs" v-model="scope.row.guideprice"
							@blur="onBlur(scope.row, scope.column)" size="mini"></el-input>
					</template>
				</el-table-column>
				<!-- <el-table-column sortable label="天数" prop="clts" width="120"> -->
					<!-- <div>88</div> -->
				<!-- </el-table-column> -->
				<el-table-column label="状态" align='center' width="120">
					<template slot-scope="scope">
						<el-tag type="success" v-if="scope.row.status == 1">待出售</el-tag>
						<el-tag type="danger" v-if="scope.row.status == 4">已预定</el-tag>
						<el-tag type="info" v-if="scope.row.status == 5">已售</el-tag>
						<el-tag type="info" v-if="scope.row.status == 6">待审核</el-tag>
					</template>
				</el-table-column>
				<el-table-column sortable label="预定人" align='center' show-overflow-tooltip>
					<template slot-scope="scope">
						<div style="font-size: 14px;">
							<div v-if="scope.row.patent.self_queued && scope.row.patent.self_queue_position == 1">{{userinfo.nickname}}</div>
							<div v-else-if="scope.row.patent.self_queued && scope.row.patent.self_queue_position != 1">平台</div>
							<div v-else-if="!scope.row.patent.self_queued && scope.row.patent.has_queue > 0">平台</div>
							<div v-if="scope.row.patent.has_queue > 0">截至:{{scope.row.patent.self_endtime}}</div>
							<!-- <div v-if="scope.row.patent.has_queue > 1">[排队:{{scope.row.patent.has_queue - 1}}人]</div> -->
						</div>
					</template>
				</el-table-column>
				<el-table-column sortable label="排队状态" align='center' show-overflow-tooltip>
					<template slot-scope="scope">
						<div style="font-size: 14px;" v-if="scope.row.patent.has_queue > 1">当前排队:{{scope.row.patent.has_queue - 1}}人</div>
						<div style="font-size: 14px;" v-if="scope.row.patent.self_queued && scope.row.patent.self_queue_position > 1">我排第{{scope.row.patent.self_queue_position - 1}}位</div>
					</template>
				</el-table-column>
				<!-- <el-table-column sortable label="预定到期时间" show-overflow-tooltip>
					<template slot-scope="scope">
						<div style="font-size: 12px;" v-if="scope.row.patent.self_endtime">
							{{scope.row.patent.self_endtime}}</div>
					</template>
				</el-table-column> -->
				<el-table-column label="操作" show-overflow-tooltip>
					<template slot-scope="scope" v-if="scope.row.status != 5">
						
						
						<div class="con-sqyd"
							v-if="scope.row.patent.self_queued && scope.row.patent.self_queue_position == 1"
							@click="sqydShow(scope.row,1)">取消预定</div>
						<div class="con-sqyd"
							v-else-if="scope.row.patent.self_queued && scope.row.patent.self_queue_position != 1"
							@click="sqydShow(scope.row,2)">取消排队</div>
						<div class="con-sqyd" v-else-if="!scope.row.patent.self_queued && scope.row.patent.has_queue == 0"
							@click="sqydShow(scope.row,3)">预定</div>
						<div class="con-sqyd" v-else-if="!scope.row.patent.self_queued && scope.row.patent.has_queue != 0"
							@click="sqydShow(scope.row,4)">排队</div>
						<div class="con-sqyd-a" v-if="scope.row.patent.has_queue > 0" @click="zlyylbShow(scope.row)">
							预定列表
						</div>
						<div class="con-sqyd-a" v-if="scope.row.patent.self_queued && scope.row.status == 4" @click="showyysq(3,scope.row.patent.queue_id)">延长时间</div>
						<div class="con-sqyd-a" @click="editpatentShow(scope.row)">编辑</div>
						<div class="con-del" @click="delitem(scope.row.id)">删除</div>
					</template>
				</el-table-column>
				<!-- {{ scope.row.date }} -->
			</el-table>
		</div>

		<el-pagination class="data-pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange"
			background :page-sizes="[10, 20, 30, 40,50,100]" :page-size="pageSize" layout=" prev, pager, next,sizes"
			:total="total">
		</el-pagination>
		<!-- 新增弹出框 -->
		<el-dialog title="新增专利" :visible.sync="adddialogVisible" width="40%">
			<div class="reg-item1">
				<el-radio-group v-model="addtype" size="small">
					<el-radio-button label="1">实时</el-radio-button>
					<el-radio-button label="2">代售</el-radio-button>
				</el-radio-group>
				<el-switch class="switch" v-model="adddtpl" active-text="批量" inactive-text="单条"></el-switch>
			</div>
			<div style="display: flex;width: 100%;" v-if="!adddtpl">
				<el-form ref="form" class="add-form" :rules="rules" :model="form" label-position='right'
					label-width="120px" @submit.native.prevent="handlereg">
					<el-form-item prop="zlh" label="专利号" required>
						<el-input size="small" v-model="form.zlh" :clearable='true' type="text"
							placeholder="请输入专利号"></el-input>
					</el-form-item>
					<el-form-item prop="zlmc" label="专利名称" required>
						<el-input size="small" v-model="form.zlmc" :clearable='true' type="text"
							placeholder="请输入专利名称"></el-input>
					</el-form-item>
					<el-form-item prop="zllx" label="专利类型" required>
						<el-select v-model="form.zllx" placeholder="请选择">
							<el-option v-for="item in options" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item prop="ly" label="领域">
						<el-input size="small" v-model="form.ly" :clearable='true' type="text"
							placeholder="请输入领域"></el-input>
					</el-form-item>
					<el-form-item prop="jfrq" label="缴费日期">
						<!-- <el-date-picker v-model="form.jfrq" align="right" type="date" placeholder="选择缴费日期"></el-date-picker> -->
						<el-input size="small" v-model="form.jfrq" :clearable='true' type="text"
							placeholder="请输入缴费日期"></el-input>
					</el-form-item>
					<el-form-item prop="zdj" label="转让裸价">
						<el-input size="small" v-model="form.zdj" :clearable='true' type="text"
							placeholder="请输入转让裸价"></el-input>
					</el-form-item>
					<!-- <el-form-item prop="zyf" label="资源方">
						<el-input size="small" v-model="form.zyf" :clearable='true' type="text"
							placeholder="请输入资源方"></el-input>
					</el-form-item> -->
					<el-form-item prop="zb" label="备注">
						<el-input type="textarea" maxlength='100' :autosize='true' :rows="3" placeholder="请输入备注"
							v-model="form.bz">
						</el-input>
					</el-form-item>
					<el-form-item prop="zb" label="是否报过高企">
						<el-radio-group v-model="form.ifgq" size="small">
							<el-radio label="1" border>是</el-radio>
							<el-radio label="2" border>否</el-radio>
						</el-radio-group>
					</el-form-item>
				</el-form>
			</div>
			<div v-if="adddtpl">
				<el-input class="no-resize" type="textarea" placeholder="在此输入专利信息" v-model="pltextarea"></el-input>
				<div class='pladdtle' style="color: red;">格式：专利类型 专利号 专利名称 交费日期 转让裸价</div>
				<div class='pladdtle'>专利类型：授权未缴费发明,下证发明,授权未缴费实用,下证实用</div>
				<div class='pladdtle'>示例：授权未缴费发明,zhuanlihao,专利名称,2025-03-08,10</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button size='small' @click="adddialogVisible = false">取 消</el-button>
				<el-button size='small' type="primary" @click="addPatent()">提 交</el-button>
			</span>
		</el-dialog>
		<!-- 预定弹出框 -->
		<el-dialog :title="yddiaTile" :visible.sync="yddialogVisible" width="40%">
			<div style="display: flex;">
				<i class="el-icon-warning" style="color: #e6a23c;font-size: 24px;margin-right: 10px;"></i>
				<div>
					【{{yddialogItem.patentnum}}】{{yddialogItem.patentname}}
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button size='small' @click="closeydtc()">取 消</el-button>
				<el-button size='small' type="primary" @click="sqyd()">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 删除弹出框 -->
		<el-dialog :title="deldiaTile" :visible.sync="deldialogVisible" width="40%">
			<el-button size='small' @click="deldialogVisible = false">取 消</el-button>
			<el-button size='small' type="primary" @click="delpatent()">确 定</el-button>
		</el-dialog>
		<!-- 一键删除弹出框 -->
		<el-dialog title="确定删除所有待售的专利吗？" :visible.sync="yjdeldialogVisible" width="40%">
			<el-button size='small' @click="yjdeldialogVisible = false">取 消</el-button>
			<el-button size='small' type="primary" @click="yjdelpatent()">确 定</el-button>
		</el-dialog>
		<!-- 出售弹出框 -->
		<el-dialog title="确定出售专利吗？" :visible.sync="shopdialogVisible" width="40%">
			<div style="display: flex;">
				<i class="el-icon-warning" style="color: #e6a23c;font-size: 24px;margin-right: 10px;"></i>
				<div>
					{{shopdialogText}}
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button size='small' @click="shopdialogVisible = false">取 消</el-button>
				<el-button size='small' type="primary" @click="shoppatent()">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 编辑弹出框 -->
		<el-dialog title="编辑专利" :visible.sync="editdialogVisible" width="40%">
			<div>
				<el-form ref="form" class="add-form" :rules="rules" :model="form" label-position='right'
					label-width="120px" @submit.native.prevent="handlereg">
					<el-form-item prop="zlh" label="专利号" required>
						<el-input size="small" v-model="form.zlh"  :clearable='true' type="text"
							placeholder="请输入专利号"></el-input>
					</el-form-item>
					<el-form-item prop="zlmc" label="专利名称" required>
						<el-input size="small" v-model="form.zlmc"  :clearable='true' type="text"
							placeholder="请输入专利名称"></el-input>
					</el-form-item>
					<el-form-item prop="zllx" label="专利类型" required>
						<el-select v-model="form.zllx" placeholder="请选择">
							<el-option v-for="item in options" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item prop="ly" label="领域">
						<el-input size="small" v-model="form.ly" :clearable='true' type="text"
							placeholder="请输入领域"></el-input>
					</el-form-item>
					<el-form-item prop="jfrq" label="缴费日期">
						<!-- <el-date-picker v-model="form.jfrq" align="right" type="date" placeholder="选择缴费日期"></el-date-picker> -->
						<el-input size="small" v-model="form.jfrq" :clearable='true' type="text"
							placeholder="请输入缴费日期"></el-input>
					</el-form-item>
					<el-form-item prop="zdj" label="转让裸价">
						<el-input size="small" v-model="form.zdj" :clearable='true' type="text"
							placeholder="请输入转让裸价"></el-input>
					</el-form-item>
					<!-- <el-form-item prop="zyf" label="资源方">
						<el-input size="small" v-model="form.zyf" :clearable='true' type="text"
							placeholder="请输入资源方"></el-input>
					</el-form-item> -->
					<el-form-item prop="zb" label="备注">
						<el-input type="textarea" maxlength='100' :autosize='true' :rows="3" placeholder="请输入备注"
							v-model="form.bz">
						</el-input>
					</el-form-item>
					<el-form-item prop="zb" label="是否报过高企">
						<el-radio-group v-model="form.ifgq" size="small">
							<el-radio label="1" border>是</el-radio>
							<el-radio label="2" border>否</el-radio>
						</el-radio-group>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button size='small' @click="editdialogVisible = false">取 消</el-button>
				<el-button size='small' type="primary" @click="editpatent()">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 历史预约记录 -->
		<el-dialog title="我的预定列表" width="60%" :visible.sync="lsyydialogTableVisible">
			<el-table :data="gridData">
				<el-table-column property="patentnum" label="专利号" width="140"></el-table-column>
				<el-table-column property="patentname" label="专利名称" width="240"></el-table-column>
				<el-table-column property="status_text" label="状态" width="80"></el-table-column>
				<el-table-column property="creattime_text" label="申请时间" width="160"></el-table-column>
				<el-table-column property="endtime_text" label="到期时间" width="160"></el-table-column>
				<el-table-column label="操作" width="150">
					<template slot-scope="scope">
						<div style="display: flex;" v-if="scope.row.status == 1">
							<div class="con-sqyd" style="margin-right: 12px;" @click='showyysq(3,scope.row.id)'>申请延长时间</div>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination class="data-pagination" @size-change="lsyyhandleSizeChange"
				@current-change="lsyyhandleCurrentChange" background :page-sizes="[5, 8, 10]" :page-size="lsyypageSize"
				layout=" prev, pager, next,sizes" :total="lsyytotal">
			</el-pagination>
		</el-dialog>
		<!-- 某条专利预定列表 -->
		<el-dialog title="预定列表" width="62%" :visible.sync="zlyydialogTableVisible">
			<el-table :data="zlyyList">
				<el-table-column property="patentnum" align='center' label="专利号" width="140"></el-table-column>
				<el-table-column property="patentname" align='center' label="专利名称" width="240"></el-table-column>
				<el-table-column property="status_text" align='center' label="状态" width="80"></el-table-column>
				<el-table-column label="申请人" align='center' width="80">
					<template slot-scope="scope">
						<div>平台</div>
					</template>
				</el-table-column>
				<el-table-column property="creattime_text" align='center' label="申请时间" width="160"></el-table-column>
				<el-table-column property="endtime_text" align='center' label="到期时间" width="160"></el-table-column>
				<el-table-column label="操作" width="200">
					<template slot-scope="scope">
						<div style="display: flex;" v-if="scope.row.status == 6">
							<div class="con-sqyd" style="margin-right: 12px;" @click='showyysq(1,scope.row.id)'>同意申请</div>
							<div class="con-sqyd-del" @click='showyysq(2,scope.row.id)'>拒绝申请</div>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination class="data-pagination" @size-change="zlyyhandleSizeChange"
				@current-change="zlyyhandleCurrentChange" background :page-sizes="[5, 8, 10]" :page-size="zlyypageSize"
				layout=" prev, pager, next,sizes" :total="zlyytotal">
			</el-pagination>
		</el-dialog>
		<!-- 同意预约 -->
		<el-dialog title="提示" :visible.sync="tyyydialogVisible" width="25%">
			<span>是否同意该条预约申请！</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="tyyydialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="tyyysq">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 拒绝预约 -->
		<el-dialog title="提示" :visible.sync="jjyydialogVisible" width="25%">
			<span>是否拒绝该条预约申请！</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="jjyydialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="jjyysq">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 延长预约 -->
		<el-dialog title="提示" :visible.sync="ycyydialogVisible" width="25%">
			<span>是否延长该条预约申请，延长1天！</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="ycyydialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="ycyysq">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import TopNav from '../../components/TopNav.vue'
	import Jsondata from '../../../data/data.json'
	import patentApi from '@/api/patent'
	export default {
		components: {
			TopNav
		},
		data() {
			return {
				userinfo:'',
				key: Math.random(),
				searval1: "", //专利号/专利名称/领域
				searh_zlh_val: '', //专利号
				searh_ly_val: '', //领域
				searh_zdj1_val: '', //转让裸价1
				searh_zdj2_val: '', //转让裸价2
				zlztcheckList: [], //专利状态
				sbztcheckList: [], //是否已报高校
				zlflcheckList:[],//专利分类
				ydztcheckList: [],
				input1: '',
				tableData: [], //列表数据
				total: 0, //数据总条数
				page: 1, //当前页码
				pageSize: 10, //列表页数
				multipleSelection: [],
				yddialogVisible: false, //预定弹出框
				yddiaTile: '预定专利？', //预定弹出框标题
				yddialogItem: '', //预定弹出框内容
				adddialogVisible: false, //新增专利弹出框
				addtype: '1', //新增类型
				adddtpl: false, //单条还是批量
				sort_field: '', //排序字段
				sort_order: '', //排序方向
				form: {
					zlh: '',
					zlmc: '',
					zllx: '', //专利类型
					ly: '', //领域
					jfrq: '', //缴费日期
					zdj: 0, //转让裸价
					zyf: '平台', //资源方
					bz: '', //备注
					ifgq: '1', //是否报过高企
				},
				rules: {
					zlh: [{
							required: true,
							message: '请输入专利号',
							trigger: 'blur'
						}
					],
					zlmc: [{
							required: true,
							message: '请输入专利名称',
							trigger: 'blur'
						},
						{
							min: 1,
							max: 200,
							message: '请输入正确输入专利名称',
							trigger: 'blur'
						}
					],
					zllx: [{
						required: true,
						message: '请选择专利类型',
						trigger: 'blur'
					}],
					ly: [{
						required: false,
						message: '请输入领域',
						trigger: 'blur'
					}],
					jfrq: [{
						required: false,
						message: '请选择缴费日期',
						trigger: 'blur'
					}],
					zdj: [{
						required: true,
						message: '请输入转让裸价',
						trigger: 'blur'
					}],
					zyf: [{
						required: true,
						message: '请输入资源方',
						trigger: 'blur'
					}],
				},
				options: [{
					value: '1',
					label: '授权未缴费发明'
				}, {
					value: '2',
					label: '下证发明'
				}, {
					value: '3',
					label: '授权未缴费实用'
				}, {
					value: '4',
					label: '下证实用'
				}, {
					value: '5',
					label: '外观'
				}],
				pltextarea: '', //批量添加内容
				deldialogVisible: false, //删除弹出框
				deldiaTile: "", //删除弹出框标题
				delids: '', //删除的id
				yjdeldialogVisible: false, //一键删除弹出框
				editdialogVisible: false, //编辑弹出框
				editid: '',
				shopdialogVisible: false,
				shopdialogText: '',
				shopid: '', //出售专利id
				lsyydialogTableVisible: false, //历史预约记录
				zlyydialogTableVisible:false,//某条专利预约记录
				zlyypage: 1, //当前页码
				zlyyid: 1, //专利列表id
				zlyypageSize: 5, //列表页数
				zlyytotal: 0, //数据总条数
				zlyyList:[],//专利预约记录
				gridData: [],
				lsyytotal: 0, //数据总条数
				lsyypage: 1, //当前页码
				lsyypageSize: 5, //列表页数
				daytotal: 0, //今日发布数量
				tyyydialogVisible:false,//同意预约申请框
				jjyydialogVisible:false,//拒绝预约申请框
				ycyydialogVisible:false,//延迟预约申请框
				tyjjyyid:'',//同意拒绝延长预约id
			};
		},
		created: function() {
			this.userinfo = JSON.parse(this.$store.state.userinfo);
			//加载专利
			this.loadPatentList();
		},
		methods: {
			tyyysq(){
				var that = this;
				patentApi.tyyypatent({
					id: that.tyjjyyid,
				}).then(res => {
					that.tyyydialogVisible = false;
					this.zlyylbShow();
				})
			},
			jjyysq(){
				var that = this;
				patentApi.jjyypatent({
					id: that.tyjjyyid,
				}).then(res => {
					that.jjyydialogVisible = false;
					this.zlyylbShow();
				})
			},
			ycyysq(){
				var that = this;
				patentApi.ycyypatent({
					id: that.tyjjyyid,
				}).then(res => {
					that.ycyydialogVisible = false;
					// that.showlsyydialog();
					that.tyjjyyid = '';
					this.loadPatentList();
				})
			},
			showyysq(type,showid){
				this.tyjjyyid = showid;
				if(type == 1){
					this.tyyydialogVisible = true;
				}else if(type == 2){
					this.jjyydialogVisible = true;
				}else if(type == 3){
					this.ycyydialogVisible = true;
				}
			},
			// 某一条专利预约记录
			zlyylbShow(e){
				var that = this;
				if(e){
					that.zlyyid = e.id;
				}
				patentApi.getmypatentyuyuelist({
					id: that.zlyyid,
					page: this.zlyypage,
					pageSize: this.zlyypageSize
				}).then(res => {
					that.zlyyList = res.data.data;
					that.zlyytotal = res.data.total;
					that.zlyydialogTableVisible = true;
				})
			},
			// pageSize 改变时会触发
			zlyyhandleSizeChange(e) {
				this.zlyypageSize = e;
				this.zlyylbShow();
			},
			// currentPage 改变时会触发
			zlyyhandleCurrentChange(e) {
				this.zlyypage = e;
				this.zlyylbShow();
			},
			// 自定义上传
			uploadelc(file){
				const formData = new FormData();
				formData.append('file',file.file);
				
				patentApi.uploadexlec(formData).then(res => {
					// console.log(res)
					this.$message("导入成功,等待后台执行！");
					this.$refs.upload.clearFiles(); //去掉文件列表
					patentApi.plscpatent({file:res.data.url}).then(res => {
						this.$message(res.msg);
					})
				})
			},
			onErrorFile(){
			   this.$message("导入失败！");
			   this.$refs.upload.clearFiles(); //去掉文件列表
			 },
			onSuccessFile(response) {
			   // 你的代码
			   this.$message("导入成功！");
			   this.$refs.upload.clearFiles(); //去掉文件列表
			},
			// 历史预约
			showlsyydialog() {
				var that = this;
				patentApi.getqueueList({
					page: this.lsyypage,
					pageSize: this.lsyypageSize
				}).then(res => {
					that.gridData = res.data.data;
					that.lsyytotal = res.data.total;
					that.lsyydialogTableVisible = true;
				})
			},
			// pageSize 改变时会触发
			lsyyhandleSizeChange(e) {
				this.lsyypageSize = e;
				this.showlsyydialog();
			},
			// currentPage 改变时会触发
			lsyyhandleCurrentChange(e) {
				this.lsyypage = e;
				this.showlsyydialog();
			},
			// 双击表格
			handleDblClick(row, column) {
				if (row.status != 1) {
					this.$message({
						message: '状态不允许修改',
						type: 'error'
					});
					return false;
				}
				console.log(row, column)
				// 避免点击过快导致多个输入框处于焦点状态
				row[column.property + 'Show'] = false

				// 避免点击其他单元格导致表格刷新 
				if (!['remarks', 'area', 'guideprice'].includes(column.property)) return
				row[column.property + 'Show'] = true
				this.key = Math.random()
				this.$nextTick(() => {
					// 以下2种方法可以实现,一直只有一个ref实例
					this.$refs.enddateinputRefs.focus();
				})
			},
			onBlur(row, column) {
				console.log(row, column)
				row[column.property + 'Show'] = false
				this.key = Math.random()

				patentApi.lineeditpatent({
					id: row.id,
					ly: row.area,
					bz: row.remarks,
					zdj: row.guideprice
				}).then(res => {
					this.$message({
						message: '编辑成功',
						type: 'success'
					});
				})
			},
			addPatentShow() {
				var that = this;
				that.form.zlh = '';
				that.form.zlmc = '';
				that.form.zllx = '';
				that.form.ly = '';
				that.form.jfrq = '';
				that.form.zdj = 0;
				that.form.zyf = '';
				that.form.bz = '';
				that.form.ifgq = '1';
				that.pltextarea = '';
				that.adddialogVisible = true;
			},
			addPatent() {
				if (this.adddtpl) {
					//批量
					if (this.pltextarea == '') {
						this.$message({
							message: '请输入专利信息',
							type: 'error'
						});
						return false;
					}
					patentApi.dtpladdpatent({
						text: this.pltextarea,
						addtype: this.addtype
					}).then(res => {
						if (res.data) {
							this.$message({
								message: res.msg + res.data + "信息有误！",
								type: 'success'
							});
						} else {
							this.$message({
								message: '批量添加成功',
								type: 'success'
							});
							this.adddialogVisible = false;
						}
						this.loadPatentList();
					})
				} else {
					//单条
					this.$refs.form.validate(valid => {
						if (valid) {
							// this.loading = true;
							this.form.addtype = this.addtype;
							patentApi.dtaddpatent(this.form).then(res => {
								this.$message({
									message: '添加成功',
									type: 'success'
								});
								this.adddialogVisible = false;
								this.loadPatentList();
							})
							// this.loading = false;
						}
					})
				}
			},
			//下面筛选条件 
			zlztCheckChange(e) {
				this.loadPatentList();
			},
			sbztcheckChange(e) {
				this.loadPatentList();
			},
			zlflcheckChange(e) {
				this.loadPatentList();
			},
			ydztcheckChange(e) {
				this.loadPatentList();
			},
			// 处理排序变化
			handleSortChange({ column, prop, order }) {
				if (prop === 'guideprice') {
					if (order === 'ascending') {
						// 升序：从低到高
						this.sort_field = 'guideprice';
						this.sort_order = 'asc';
					} else if (order === 'descending') {
						// 降序：从高到低
						this.sort_field = 'guideprice';
						this.sort_order = 'desc';
					} else {
						// 取消排序
						this.sort_field = '';
						this.sort_order = '';
					}
					this.loadPatentList();
				}
			},
			searchInput() {
				this.loadPatentList();
			},
			zlmcInput() {
				this.loadPatentList();
			},
			zlhInput() {
				this.loadPatentList();
			},
			zdjInput1(e) {
				if (this.searh_zdj2_val == '') {
					this.loadPatentList();
				} else {
					if (this.searh_zdj1_val <= this.searh_zdj2_val) {
						this.loadPatentList();
					}
				}
			},
			zdjInput2(e) {
				if (this.searh_zdj1_val == '') {
					this.loadPatentList();
				} else {
					if (this.searh_zdj1_val <= this.searh_zdj2_val) {
						this.loadPatentList();
					}
				}
			},
			// pageSize 改变时会触发
			handleSizeChange(e) {
				this.pageSize = e;
				this.loadPatentList();
			},
			// currentPage 改变时会触发
			handleCurrentChange(e) {
				this.page = e;
				this.loadPatentList();
			},
			// 预定
			sqydShow(item, index) {
				if (index == 1) {
					this.yddiaTile = '申请取消预定？';
				} else if (index == 2) {
					this.yddiaTile = '申请取消排队？';
				} else if (index == 3) {
					this.yddiaTile = '预定专利？';
				} else if (index == 4) {
					this.yddiaTile = '排队专利？';
				}
				this.yddialogItem = item;
				this.yddialogVisible = true;
			},
			closeydtc() {
				this.yddialogItem = '';
				this.yddialogVisible = false;
			},
			sqyd() {
				patentApi.setreserve({
					id: this.yddialogItem.id
				}).then(res => {
					console.log(res)
					this.$message({
						message: res.msg,
						type: 'success'
					});
					this.closeydtc();
					this.loadPatentList();
				})
			},
			// 专利数据
			loadPatentList() {
				//类型
				var lx = '';
				this.zlztcheckList.forEach(item => {
					lx = lx + item + ","
				})
				if (lx.length > 0) {
					lx = lx.slice(0, -1);
				}
				// 高校
				var sb = '';
				this.sbztcheckList.forEach(item => {
					sb = sb + item + ","
				})
				if (sb.length > 0) {
					sb = sb.slice(0, -1);
				}
				// 专利分类
				var zlfl = '';
				this.zlflcheckList.forEach(item => {
					zlfl = zlfl + item + ","
				})
				if (zlfl.length > 0) {
					zlfl = zlfl.slice(0, -1);
				}
				// 状态
				var ydzt = '';
				this.ydztcheckList.forEach(item => {
					ydzt = ydzt + item + ","
				})
				if (ydzt.length > 0) {
					ydzt = ydzt.slice(0, -1);
				}
				patentApi.getmypatentlist({
					page: this.page,
					pageSize: this.pageSize,
					lx: lx,
					sb: sb,
					zdj: this.searh_zdj1_val,
					zgj: this.searh_zdj2_val,
					zlname: this.searh_ly_val,
					zlh: this.searh_zlh_val,
					search: this.searval1,
					ydzt: ydzt,
					zlfl:zlfl,
					sort_field: this.sort_field,
					sort_order: this.sort_order
				}).then(res => {
					console.log(res)
					this.tableData = res.data.data;
					this.tableData.forEach(item => {
						item.isEdit = false;
					});
					this.total = res.data.total;
					this.daytotal = res.data.daycount;
				})
			},
			// 获取索引
			getIndex(index) {
				return index + 1;
			},
			toggleSelection(rows) {
				if (rows) {
					rows.forEach(row => {
						this.$refs.multipleTable.toggleRowSelection(row);
					});
				} else {
					this.$refs.multipleTable.clearSelection();
				}
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			delitem(id){
				this.delids = id;
				this.deldiaTile = '确认删除当前专利?'
				this.deldialogVisible = true;
			},
			// 删除专利
			delzl() {
				if (this.multipleSelection.length == 0) {
					this.$message.error('请选择要删除的专利');
				} else {
					var ids = '';
					this.multipleSelection.forEach(item => {
						ids = ids + item.id + ",";
					})
					if (ids.length > 0) {
						ids = ids.slice(0, -1);
					}
					this.delids = ids;
					this.deldiaTile = '确认删除选中的' + this.multipleSelection.length + '个专利?'
					this.deldialogVisible = true;
				}
			},
			// 确定删除专利
			delpatent() {
				if (this.delids == '') {
					this.$message.error('请选择要删除的专利');
					return false;
				}
				patentApi.delpatent({
					ids: this.delids
				}).then(res => {
					console.log(res)
					this.$message({
						message: res.msg,
						type: 'success'
					});
					this.deldialogVisible = false;
					this.loadPatentList();
				})
			},
			// 一键删除专利
			yjdelzl() {
				this.yjdeldialogVisible = true;
			},
			yjdelpatent() {
				patentApi.yjdelpatent().then(res => {
					this.$message({
						message: res.msg,
						type: 'success'
					});
					this.yjdeldialogVisible = false;
					this.loadPatentList();
				})
			},
			editpatentShow(row) {
				var that = this;
				that.editid = row.id;
				that.form.zlh = row.patentnum;
				that.form.zlmc = row.patentname;
				that.form.zllx = row.type + "";
				that.form.ly = row.area;
				that.form.jfrq = row.paymenttime_text;
				that.form.zdj = row.guideprice;
				that.form.zyf = row.resourceprovider;
				that.form.bz = row.remarks;
				that.form.ifgq = row.ifhigh + "";
				this.editdialogVisible = true;
			},
			editpatent() {
				//单条
				this.$refs.form.validate(valid => {
					if (valid) {
						// this.loading = true;
						this.form.id = this.editid;
						patentApi.editpatent(this.form).then(res => {
							this.$message({
								message: '编辑成功',
								type: 'success'
							});
							this.editdialogVisible = false;
							this.loadPatentList();
						})
						// this.loading = false;
					}
				})
			},
			// 出售专利
			shoppatentShow(row) {
				this.shopid = row.id;
				this.shopdialogText = '【' + row.patentnum + '】' + row.patentname;
				this.shopdialogVisible = true;
			},
			shoppatent() {
				if (this.shopid == '') {
					this.$message.error('请选择要出售的专利');
					return false;
				}
				patentApi.shoppatent({
					id: this.shopid
				}).then(res => {
					this.$message({
						message: res.msg,
						type: 'success'
					});
					this.shopdialogVisible = false;
					this.loadPatentList();
				})
			},
			// 复制专利
			copyzl() {
				if (this.multipleSelection.length == 0) {
					this.$message.error('请选择要复制的专利');
				} else {
					var text = '';
					this.multipleSelection.forEach(item => {
						if (item.type == 1) {
							text = text + '授权未缴费发明 ' + item.patentnum + ' ' + item.patentname + ' ' + item.area + ' ' + item
								.paymenttime_text + ' ' + item.guideprice + ' ' + '\n';
						} else if (item.type == 2) {
							text = text + '下证发明 ' + item.patentnum + ' ' + item.patentname + ' ' + item.area + ' ' + item
								.paymenttime_text + ' ' + item.guideprice + ' ' + '\n';
						} else if (item.type == 3) {
							text = text + '授权未缴费实用 ' + item.patentnum + ' ' + item.patentname + ' ' + item.area + ' ' + item
								.paymenttime_text + ' ' + item.guideprice + ' ' + '\n';
						} else if (item.type == 4) {
							text = text + '下证实用 ' + item.patentnum + ' ' +  item.patentname + ' ' + item.area + ' ' + item
								.paymenttime_text + ' ' + item.guideprice + ' ' + '\n';
						} else if (item.type == 5) {
							text = text + '外观 ' + item.patentnum + ' ' + item.patentname + ' ' + item.area + ' ' + item.paymenttime_text +
								' ' + item.guideprice + ' ' + '\n';
						}
					})
					this.$copyText(text).then(
						(e) => {
							this.$message({
								message: '已成功复制到剪切板',
								type: 'success'
							});
						},
						(err) => {
							this.$message.error('复制失败');
						}
					);

				}
			},
			// 导出数据
			exportexecl() {
				var ids = '';
				if (this.multipleSelection.length > 0) {
					this.multipleSelection.forEach(item => {
						ids = ids + item.id + ',';
					})
				}
				if (ids.length > 0) {
					ids = ids.slice(0, -1);
				}
				
				//类型
				var lx = '';
				this.zlztcheckList.forEach(item => {
					lx = lx + item + ","
				})
				if (lx.length > 0) {
					lx = lx.slice(0, -1);
				}
				// 高校
				var sb = '';
				this.sbztcheckList.forEach(item => {
					sb = sb + item + ","
				})
				if (sb.length > 0) {
					sb = sb.slice(0, -1);
				}
				// 状态
				var ydzt = '';
				this.ydztcheckList.forEach(item => {
					ydzt = ydzt + item + ","
				})
				if (ydzt.length > 0) {
					ydzt = ydzt.slice(0, -1);
				}
				// 专利分类
				var zlfl = '';
				this.zlflcheckList.forEach(item => {
					zlfl = zlfl + item + ","
				})
				if (zlfl.length > 0) {
					zlfl = zlfl.slice(0, -1);
				}
				patentApi.exportexecl({
					id:ids,
					lx: lx,
					sb: sb,
					zdj: this.searh_zdj1_val,
					zgj: this.searh_zdj2_val,
					zlname: this.searh_ly_val,
					zlh: this.searh_zlh_val,
					search: this.searval1,
					ydzt: ydzt,
					my:1,
					zlfl:zlfl
				},{responseType:'blob'}).then(res=>{
					var n = new Blob([res.data],{
						type: "text/plain;charset=utf-8"
					})
					  , a = document.createElement("a")
					  , r = window.URL.createObjectURL(n);
					a.href = r,
					a.download = "专利清单.xlsx",
					document.body.appendChild(a),
					a.click(),
					document.body.removeChild(a)
				})
			},
			// 复制文本
			copytxt(txt) {
				this.$copyText(txt).then(
					(e) => {
						this.$message({
							message: '已成功复制到剪切板',
							type: 'success'
						});
					},
					(err) => {
						this.$message.error('复制失败');
					}
				);
			},



		}
	}
</script>

<style lang="less">
	.con-tle-box {
		padding: 8px 20px 0 20px;
		cursor: pointer;
		display: flex;

		.popover {
			float: left;
		}

		.con-tle-right {
			margin-left: auto;
			cursor: pointer;
			font-weight: 700;
			color: #666;
		}
	}

	.reg-item1 {
		display: flex;
		align-items: center;
		margin-bottom: 10px;

		.switch {
			margin-left: auto;
		}

	}

	.add-form {
		width: 100%;

		.el-form-item {
			margin-bottom: 15px;
		}
	}

	// 批量添加
	.no-resize .el-textarea__inner {
		height: 300px;
		resize: none;
	}

	.pladdtle {
		margin-top: 8px;
	}

	.search-box {
		width: 96%;
		margin: 30px auto 12px auto;
		background-color: #ffffff;
		border-radius: 8px;
		padding: 15px 0;

		.search-item1 {
			display: flex;
			
				
			
			
			.item-con {
				display: flex;
				height: 40px;
				align-items: center;
				.searchtxt {
					width: 370px;
				}

				.item-con-tle {
					width: 110px;
					font-size: 15px;
					text-align: right;
				}
				.item-ts-tle{
					font-size: 13px;
					color: #606266;
					margin-left: 12px;
				}
			}
		}

		.check-item {
			display: flex;
			height: 40px;
			align-items: center;

			.item-con-tle {
				width: 110px;
				font-size: 15px;
				text-align: right;
			}
		}

		.fw-item {
			display: flex;
			height: 40px;
			align-items: center;

			.item-con-tle {
				width: 110px;
				font-size: 15px;
				text-align: right;
			}

			.item-con-ipt {
				width: 180px;
			}
		}
	}

	.el-table th.el-table__cell>.cell {
		padding: 0 14px !important;
	}

	.con-box {
		width: 96%;
		margin: 0 auto;
		background-color: #ffffff;

		:deep(.el-table__body tr:nth-child(odd)) {
			background-color: #fef0f0;
		}

		.con-zlxx {
			.con-zlxx-1 {
				font-size: 12px;
				display: flex;
				align-items: center;

				.code {
					font-size: 14px;
					font-weight: bold;
					color: #215e21;
					cursor: pointer;
					vertical-align: middle;
					margin-right: 6px;
				}
				.code-a{
					font-size: 14px;
					font-weight: bold;
					color: #4d4dff;
					cursor: pointer;
					vertical-align: middle;
					margin-right: 6px;
				}
			}

			.con-zlxx-2 {
				font-size: 12px;
				display: flex;
				align-items: center;

				.code {
					font-size: 14px;
					font-weight: bold;
					color: #4d4dff;
					cursor: pointer;
					vertical-align: middle;
					margin-right: 6px;
				}
			}

			.con-zlxx-3 {
				font-size: 12px;
				display: flex;
				align-items: center;
			}

			.con-zlxx-4 {
				font-size: 12px;
				display: flex;
				align-items: center;
			}
		}
		.con-sqyd-a{
			cursor: pointer;
			color: #409eff;
			width: 60px;
			height: 25px;
			line-height: 25px;
			text-align: center;
		}
		.con-sqyd-b{
			cursor: pointer;
			color: red;
			border:1px solid red;
			border-radius: 6px;
			width: 60px;
			height: 25px;
			line-height: 23px;
			text-align: center;
			font-size: 13px;
		}
		.con-sqyd-b:hover{
			color: #ffffff;
			background-color: red;
		}
		.con-sqyd {
			cursor: pointer;
			color: #409eff;
			margin-top: 3px;
		}

		.con-del {
			cursor: pointer;
			color: red;
			width: 60px;
			height: 25px;
			line-height: 25px;
			text-align: center;
		}
	}
	
	.con-sqyd {
		cursor: pointer;
		color: #409eff;
		margin-top: 3px;
	}
	.con-sqyd-del{
		cursor: pointer;
		color: red;
		margin-top: 3px;
	}
	
	// 分页器
	.data-pagination {
		margin-top: 30px;
		margin-bottom: 60px;
		padding: 10px 15px;
		display: flex;
		justify-content: center;

		.el-pager .number {
			background: #fff !important;
			color: #000000 !important;
			font-weight: normal !important;
		}

		.el-pager .active {
			background: #409EFF !important;
			color: #ffffff !important;
			font-weight: normal !important;
		}

		.btn-next,
		.btn-prev {
			background: #fff !important;
			color: #000000 !important;
		}
	}
</style>